import {Component, ElementRef, HostListener, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {CarouselModule, OwlOptions} from "ngx-owl-carousel-o";
@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, CarouselModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit{
  counted = false;

  carouselItems: any [] = [
    {
      image: 'assets/images/education.jpg',
      title: 'Education',
      content: 'We believe in empowering our clients through education.'
    },
    {
      image: 'assets/images/assessment.jpg',
      title: 'Assessment',
      content: 'Analysis allows us to identify areas for improvement and tailor our services.'
    },
    {
      image: 'assets/images/negotiation.jpg',
      title: 'Negotiation',
      content: 'We leverage our industry relationships to maximize your travel budget.'
    },
    {
      image: 'assets/images/communication.jpg',
      title: 'Communication',
      content: 'We maintain open lines of communication with our clients.'
    },
    {
      image: 'assets/images/design.jpg',
      title: 'Design',
      content: 'We design customized travel programs reflecting unique needs.'
    },
    {
      image: 'assets/images/measurement.jpg',
      title: 'Measurement',
      content: 'Our reporting tools provide insights into spending and satisfaction.'
    }
  ];

  carouselOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    lazyLoad: true,
    dots: true,
    autoHeight: true,
    autoWidth: true,
    autoplayTimeout: 7000,
    smartSpeed: 800,
    margin: 20,
    nav: false,
    responsive: {
      0: { items: 1 },
      575: { items: 3 },
      991: { items: 2 },
      1300: { items: 3 },
      1400: { items: 3 }
    }
  };

  ngOnInit(): void {
  }
  constructor(private el : ElementRef) {
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const counterSection = this.el.nativeElement.querySelector('#counter');
    if (!counterSection || this.counted) return;

    const counterTop = counterSection.offsetTop - window.innerHeight;
    if (window.scrollY > counterTop) {
      this.animateCounters();
      this.counted = true;
    }
  }

  private animateCounters(): void {
    const counters = this.el.nativeElement.querySelectorAll('.count');
    counters.forEach((counter: HTMLElement) => {
      const targetCount = parseInt(counter.getAttribute('data-count') || '0', 10);
      let currentCount = 0;
      const duration = 2000; // Animation duration
      const stepTime = Math.abs(Math.floor(duration / targetCount));

      const interval = setInterval(() => {
        currentCount++;
        counter.textContent = currentCount.toString();
        if (currentCount >= targetCount) {
          clearInterval(interval);
          counter.textContent = targetCount.toString();
        }
      }, stepTime);
    });
  }
}
